(ns dre.utils.fsm
  (:require
    [day8.re-frame.tracing :refer-macros [fn-traced]]))


;; https://cognitect.com/blog/2017/8/14/restate-your-ui-creating-a-user-interface-with-re-frame-and-state-machines

(defn update-next-state
  [db transition fsm]
  (if-let [next-state (get-in fsm [(:state db) transition])]
    (assoc db :state next-state)
    db))


(defn ->next-state-handler
  [fsm]
  (fn-traced
    [db [event]]
    (update-next-state db event fsm)))
